export default __webpack_public_path__ + "static/media/rentika-loading.1c568905.gif";